import MasterItemEntity from "../entities/master_item.entity";

export default interface MasterDataRepository {
    getCallTypes: () => Promise<MasterItemEntity[]>;
}

export const MasterDataRepositoryName = "MasterDataRepository";